$(document).ready(function(){
  $('.banner-carousel').slick({
    dots:true,
    arrows:false,
    autoplay:true,
    autoplaySpeed:5000
  });


  $('.slick.marquee').slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    pauseOnHover:false
  });


  $('.insta-row').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
     pauseOnHover:false
  });

  $('.shop-the-look__looks-list').slick({
    dots:true,
    arrows:true
  });
});

// function for aplly anything on mobile device
function checkScreenSize() {
  if ($(window).width() < 750) {
    $('.multicolumn-background .content-row').slick({
      centerMode: true,
      centerPadding: '50px',
      slidesToShow: 1,
      arrows: false
    });

    $('.shopify-section.product-video .video-mob-slider .card-list').slick({
      slidesToShow: 1.5,
      arrows: false,
      infinite: false
    });
    
    
  } else {
    $('.multicolumn-background .content-row').slick('unslick');
  }
}
  
// Run on load
$(document).ready(function () {
  checkScreenSize();
});
  
// Run on window resize
$(window).resize(function () {
  checkScreenSize();
});


/* */

function updateMediaVisibility() {
  const mediaItems = document.querySelectorAll('.product__media-item[data-color]');
  const selectedColorSpan = document.querySelector('span[data-selected-value]');
  const selectedColor = selectedColorSpan ? selectedColorSpan.textContent.trim().toLowerCase() : null;

  mediaItems.forEach(item => {
    const color = item.getAttribute('data-color')?.trim().toLowerCase();
    item.style.display = (color === selectedColor) ? '' : 'none';
  });
}

// Run once initially
updateMediaVisibility();

// Observe span[data-selected-value] for changes
const targetSpan = document.querySelector('span[data-selected-value]');
if (targetSpan) {
  const observer = new MutationObserver(() => {
    updateMediaVisibility();
  });

  observer.observe(targetSpan, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

document.querySelectorAll('.add-to-cart-btn').forEach(function (btn) {
  btn.addEventListener('click', function () {
    // 1. Open the cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      cartDrawer.classList.remove('is-empty');
    }

    // 2. Add .cart-count-bubble inside #cart-icon-bubble (if not present)
    const cartIconBubble = document.querySelector('#cart-icon-bubble');
    if (cartIconBubble && !cartIconBubble.querySelector('.cart-count-bubble')) {
      const bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.textContent = '1'; // You can replace this with the actual cart item count if needed
      cartIconBubble.appendChild(bubble);
    }
  });
});


if (window.matchMedia('(min-width: 750px)').matches) {
  document.querySelectorAll(
    '.shopify-section:has(facet-filters-form) .facets-vertical.page-width aside#main-collection-filters details'
  ).forEach(details => {
    details.open = true;
  });
}


  function copyToClipboard(text) {
    var tempTextArea = $("<textarea>");
    tempTextArea.val(text);
    $("body").append(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    tempTextArea.remove();
  }

  // Offer code click
  $(document).on("click", ".offer_code", function (e) {
    var $this = $(this),
      copiedText = $this.attr("data-clipboard-text"),
      $copiedStatus = $this.find(".copyStatus");

    copyToClipboard(copiedText);
    console.log(copiedText);
    $copiedStatus.text("Copied!").fadeIn(200, function () {
      setTimeout(function () {
        $copiedStatus.fadeOut(1000);
      }, 1000);
    });
  });

document.querySelectorAll('.mobile-facets__open-wrapper').forEach(wrapper => {
  wrapper.addEventListener('click', function () {
    if (window.matchMedia('(max-width: 767px)').matches) {
      document.querySelectorAll(
        '#FacetFiltersFormMobile details, #FacetsWrapperMobile details'
      ).forEach(details => {
        details.open = true;
      });
    }
  });
});

document.querySelectorAll('#product-grid .product-grid .grid__item').forEach((item) => {
  if (!item.innerHTML.trim()) {
    item.remove();
  }
});


$(document).ready(function () {
  var chatinterval = setInterval(function () {
    var slider = $('product-recommendations ul').length;
    console.log(slider);

    if (slider == 1) {
      console.log("Apply Slider");

      $('.related-products .product-grid').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        centerMode: false,
        arrows: true,
        // variableWidth: true,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              dots: true,
              arrows: false,
              slidesToScroll: 2,
              slidesToShow: 2
            }
          }
        ]
      });

      clearInterval(chatinterval);
    } else {
      console.log("Not Get Product Div");
    }
  }, 1000);
});


document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".unit_tab");
    const tables = document.querySelectorAll(".unit_table");
    const currentUnitInput = document.querySelector(".current_sizing_unit");

    function switchUnit(unit) {
      // update tabs
      tabs.forEach(tab => {
        tab.classList.toggle("unit_selected", tab.dataset.target === unit);
      });

      // update tables
      tables.forEach(table => {
        table.classList.toggle("active", table.classList.contains(unit));
      });

      // update hidden input
      if (currentUnitInput) currentUnitInput.value = unit;
    }

    // init with hidden input value
    switchUnit(currentUnitInput.value);

    // click handler
    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        switchUnit(this.dataset.target);
      });
    });
  });